import * as React from "reactn";

export function useGlobal(key) {
  const [state] = React.useGlobal<TODO>(key);
  const dispatch = React.useDispatch<TODO>(reducer, key);
  return [state, dispatch];
}

export const clearGlobal = React.resetGlobal;

export function reducer(state = {}, payload) {
  const newState = {
    ...state,
    ...payload,
  };
  return newState;
}
